// extracted by mini-css-extract-plugin
module.exports = {"closeContent":"ImageModal_closeContent__2SwYs","close":"ImageModal_close__2mJ4u","imgContainer":"ImageModal_imgContainer__3WzxQ","img":"ImageModal_img__r7Av2"};